exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contact h1[data-v-0243a918]{font-size:28px;font-weight:400}.contact .office[data-v-0243a918]{padding-bottom:25px;border-bottom:1px solid #f2f2f2}.contact .office dt[data-v-0243a918]{font-weight:700;margin:30px 0 10px 0}.contact .office dd[data-v-0243a918]{line-height:25px}.contact .department dt[data-v-0243a918]{font-weight:700;margin:25px 0 10px 0}.contact .department dd[data-v-0243a918]{line-height:25px}.contact .baiDuMap[data-v-0243a918]{margin-top:20px;width:100%;height:399px}", ""]);

// exports
